// ContactInformation.js
// ============================================================================
// TWO ITEMS NEED HUMAN INPUT BEFORE LAUNCH:
// 1. BUSINESS HOURS were not supplied by Ivipass. The card is retained but the
//    inherited 'Monday to Friday, 9am-6pm' hours have been removed rather than
//    guessed. Real opening hours must be added, or the card deleted.
// 2. The address shown is the REGISTERED OFFICE from Companies House. It may be
//    a company formation agent / mail-forwarding address rather than somewhere
//    clients can visit. The card is labelled 'Registered Office' for that
//    reason. If Ivipass has a separate visitor address, use that instead.
// Phone (07882 767822) and email (info@ivipass.com) are as supplied.
// ============================================================================
import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, Clock, MapPin } from 'lucide-react';

const ContactInformation = () => {
  const contactInfo = [
    {
      icon: Mail,
      title: 'Email',
      content: 'info@ivipass.com',
      link: 'mailto:info@ivipass.com',
      color: 'blue'
    },
    {
      icon: Phone,
      title: 'Phone',
      content: ['07882 767822'],
      color: 'green'
    },
    {
      icon: Clock,
      title: 'Business Hours',
      content: ['Opening hours to be confirmed', 'Email or call to arrange a time'],
      color: 'orange'
    },
    {
      icon: MapPin,
      title: 'Registered Office',
      content: ['Chartax Suite 103b', '18-36 Wellington Street', 'London SE18 6PF'],
      color: 'purple'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'border-t-blue-500',
      green: 'border-t-green-500',
      orange: 'border-t-orange-500',
      purple: 'border-t-purple-500'
    };
    return colors[color] || 'border-t-blue-500';
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-4">
            Contact Information
          </h2>
          <p className="text-gray-600 text-sm font-light">
            Ivipass, the trading name of IMMIGRATION VISA &amp; PASSPORT SERVICES LIMITED, registered in England and Wales, company number 09292427
          </p>
        </motion.div>

        {/* Contact Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {contactInfo.map((info, index) => {
            const Icon = info.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className={`bg-white p-6 border-t-2 ${getColorClasses(info.color)} hover:shadow-lg transition-shadow`}
              >
                <Icon size={32} className="text-gray-700 mb-4" />
                
                <h3 className="text-lg font-semibold text-primary mb-3 leading-tight">
                  {info.title}
                </h3>
                
                <div className="text-gray-600 text-sm font-light leading-relaxed">
                  {info.link ? (
                    <a 
                      href={info.link}
                      className="hover:text-secondary transition-colors"
                    >
                      {info.content}
                    </a>
                  ) : Array.isArray(info.content) ? (
                    info.content.map((line, i) => (
                      <p key={i}>{line}</p>
                    ))
                  ) : (
                    <p>{info.content}</p>
                  )}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ContactInformation;
